import { BillingTransferRequestType } from "@common/constants/domains/billing/billingTransferRequest";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { ClientDetailsRow } from "./views/clientViewConfig";

export function useTransferBillingFromClientRequest(client: ClientDetailsRow) {
    const activeOrganization = useActiveOrganization();
    const canManageOrganizationBilling = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_BILLING,
    );

    if (!canManageOrganizationBilling || !activeOrganization) {
        return null;
    }
    return (
        client.pendingTransferRequests?.find(
            (request) =>
                request.organizationId === activeOrganization.id &&
                request.type ===
                    BillingTransferRequestType.WORKSPACE_TO_ORGANIZATION,
        ) ?? null
    );
}
